import React, { Component } from 'react';
import { Table, Space, message, Form, Row, Col, Button, Input, Select, DatePicker, Typography } from 'antd';
import { formItemLayout2 as formItemLayout } from '../../util/formItemLayoutConfig';
import send from '../../util/request';
import './style.less';

const { Option } = Select;
const { RangePicker } = DatePicker;

const statusIndexToText = {
  "-1": "全部",
  "0": "未发布",
  "1": "已发布",
  "2": "已完成",
  "3": "已终止",
  "4": "已失效"
};

const reportStatusIndexToText = {
  "-1": "全部",
  "0": "未提报",
  "1": "已提报",
  "2": "已取消"
};

class reportedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      provinceList: [],
      cityList: [],
      provinceId: '',
      cityId: null
    };
  }
  columns = [
    {
      title: '统采公司名称',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      align: 'center',
    },
    {
      title: '统采公司编码',
      dataIndex: 'tripartite_code',
      key: 'tripartite_code',
      align: 'center',
    },
    {
      title: '采购公司名称',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      align: 'center',
    },
    {
      title: '采购公司编码',
      dataIndex: 'buyer_code',
      key: 'buyer_code',
      align: 'center',
    },
    {
      title: '计划采购开始日期',
      dataIndex: 'plan_start_time',
      key: 'plan_start_time',
      align: 'center',
    },
    {
      title: '计划采购结束日期',
      dataIndex: 'plan_end_time',
      key: 'plan_end_time',
      align: 'center',
    },
    {
      title: '计划收集开始日期',
      dataIndex: 'task_start_time',
      key: 'task_start_time',
      align: 'center',
    },
    {
      title: '计划收集结束日期',
      dataIndex: 'task_end_time',
      key: 'task_end_time',
      align: 'center',
    },
    {
      title: '计划名称',
      dataIndex: 'task_name',
      key: 'task_name',
      align: 'center',
    },
    {
      title: '计划名称编码',
      dataIndex: 'order_no',
      key: 'order_no',
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
    },
    {
      title: '商品等级',
      dataIndex: 'level',
      key: 'level',
      align: 'center',
    },
    {
      title: '商品产地',
      dataIndex: 'place',
      key: 'place',
      align: 'center',
    },
    {
      title: '商品单位',
      dataIndex: 'unit',
      key: 'unit',
      align: 'center',
    },
    {
      title: '商品规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
    },
    {
      title: '商品价格（元）',
      dataIndex: 'sale_price',
      key: 'sale_price',
      align: 'center',
    },
    {
      title: '单位重量(KG)',
      dataIndex: 'weight',
      key: 'weight',
      align: 'center',
    },
    {
      title: '提报需求量',
      dataIndex: 'submit_number',
      key: 'submit_number',
      align: 'center',
      render: (text, record) => {
        let value = Number(text).toFixed(0);
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'submit_number')}></Input>;
      }
    },
    {
      title: '提报重量(KG)',
      dataIndex: 'submit_weight',
      key: 'submit_weight',
      align: 'center',
    },
    {
      title: '所属SVC',
      dataIndex: 'svc_name',
      key: 'svc_name',
      align: 'center',
    },
    {
      title: '需求区域',
      dataIndex: 'area',
      key: 'area',
      align: 'center',
      render: (text, record) => {
        return <span>{record.province_name + '-' + record.city_name}</span>;
      }
    },
    {
      title: '提报状态',
      dataIndex: 'submit_status',
      key: 'submit_status',
      align: 'center',
      render: (text, record) => (
        <span>{reportStatusIndexToText[record.submit_status]}</span>
      )
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      render: (text, record) => (
        <Space size="middle">
          {
            !record.isEditing && +(record.submit_op) !== 2 && (
              <Typography.Link onClick={() => this.handleEdit(record)}>修改</Typography.Link>
            )
          }
          {
            record.isEditing && (
              <Typography.Link onClick={() => this.handleSave(record)}>保存</Typography.Link>
            )
          }
        </Space>
      ),
    },
  ]

  formRef = React.createRef();

  componentDidMount() {
    this.requestAreaData();
    this.requestReportedList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestAreaData(pid = 0) {
    send({
      url: '/ipp/order-plan-task/area',
      method: 'GET',
      params: {
        pid
      }
    }).then((res) => {
      if (res.data && res.data.code === 0) {
        const { data = [] } = res.data;
        if (pid === 0) {
          this.setState({
            provinceList: data
          });
        } else {
          this.setState({
            cityList: data
          });
        }
      }
    });
  }
  handleQuery = (values) => {
    const { productName, productCode, productLevel, productPlace, supplierName, supplierCode, taskName, taskNo, status = -1 } = values;

    this.setState({
      productName,
      productCode,
      productLevel,
      productPlace,
      supplierName,
      supplierCode,
      taskName,
      taskNo,
      status,
      currentPage: 1,
    });
    this.requestReportedList();
  }
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState({
      currentPage: 1,
      productName: '',
      productCode: '',
      productLevel: '',
      productPlace: '',
      supplierName: '',
      supplierCode: '',
      taskName: '',
      taskNo: '',
      status: -1,
      startTime: '',
      endTime: '',
      provinceId: '',
      cityId: null
    }, () => {
      this.requestReportedList();
    });
  }
  requestReportedList() {
    const { currentPage, pageSize, productName, productCode, productLevel, productPlace, supplierName, supplierCode, taskName, taskNo, status = -1, startTime, endTime, provinceId, cityId } = this.state;
    let params = {
      page: currentPage,
      limit: pageSize,
      sale_name: productName,
      sku_no: productCode,
      level: productLevel,
      place: productPlace,
      order_no: taskNo,
      task_name: taskName,
      province_id: provinceId,
      supplier_name: supplierName,
      tripartite_code: supplierCode,
      city_id: cityId || '',
      status,
      task_start_time: startTime,
      task_end_time: endTime,
      submit_status: 1 //  0-未提报 1-已提报 2-已取消
    };
    if (+(status) === -1) {
      delete params.status;
    }
    send({
      url: '/ipp/order-plan-task/submit-select',
      method: 'GET',
      params,
    }).then((res) => {
      this.setState({
        loading: false
      });
      if (res.data && res.data.code === 0) {
        let { data = [], total } = res.data.data;
        this.setState({
          list: data,
          total
        });
      }
    });
  }
  handleEdit = (record) => {
    record.isEditing = true;
    let { list } = this.state;
    let index = list.findIndex(obj => String(obj.id) === String(record.id));
    if (index !== -1) {
      list[index] = record;
      this.setState({
        list
      });
    }
  }
  valueChanged = (event, record, key) => {
    let value = event.target.value;
    value = Number(value.replace(/\D/g, ''));
    record[key] = value;
    let { list } = this.state;
    let index = list.findIndex(obj => String(obj.id) === String(record.id));
    if (index !== -1) {
      list[index] = record;
      this.setState({
        list
      });
    }
  }
  handleSave = (record) => {
    record.isEditing = false;
    let { list } = this.state;
    let index = list.findIndex(obj => String(obj.id) === String(record.id));
    if (index !== -1) {
      list[index] = record;
      this.setState({
        list
      });
    }

    // 更新需求数量
    const { id, submit_status, submit_number } = record;
    let data = {
      submit_id: id,
      submit_status,
      submit_number,
    };
    send({
      url: '/ipp/order-plan-task/submit-modify',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('需求数量更新成功');
        this.requestReportedList();
      } else {
        message.error(res.data.msg, 2);
      }
    });
  }

  provinceChanged = (value) => {
    this.setState({
      provinceId: value,
      cityId: '',
      cityList: []
    });
    this.requestAreaData(value);
  }

  cityChanged = (value) => {
    this.setState({
      cityId: value
    });
  }

  dateChanged = (date, dateString) => {
    this.setState({
      startTime: dateString[0],
      endTime: dateString[1]
    });
  }

  render() {
    const { list, loading, currentPage, pageSize, total, provinceList, cityList, cityId } = this.state;

    return (
      <div className="reported-list">
        <div className="title">我的已提报计划</div>
        <div style={{ marginTop: '20px' }}>
          <Form
            ref={this.formRef}
            {...formItemLayout}
            onFinish={this.handleQuery}>
            <Row>
              <Col span={8}>
                <Form.Item label='日期' name="date">
                  <RangePicker onChange={this.dateChanged} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品名称' name="productName">
                  <Input maxLength={100} placeholder='请输入商品名称' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品编码' name="productCode">
                  <Input maxLength={100} placeholder='请输入商品编码' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品等级' name="productLevel">
                  <Input maxLength={100} placeholder='请输入商品等级' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品产地' name="productPlace">
                  <Input maxLength={100} placeholder='请输入商品产地' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='所属区域' name="area">
                  <div style={{ display: 'flex' }}>
                    <Select placeholder='省' onChange={this.provinceChanged}>
                      {
                        provinceList.map(obj => <Option key={obj.id} value={obj.id}>{obj.name}</Option>)
                      }
                    </Select>
                    <Select placeholder='市' onChange={this.cityChanged} value={cityId}>
                      {
                        cityList.map(obj => <Option key={obj.id} value={obj.id}>{obj.name}</Option>)
                      }
                    </Select>
                  </div>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='统采公司' name="supplierName">
                  <Input maxLength={100} placeholder='请输入统采公司名称' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='统采公司编码' name="supplierCode">
                  <Input maxLength={100} placeholder='请输入统采公司编码' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='计划名称' name="taskName">
                  <Input maxLength={100} placeholder='请输入计划名称' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='计划编码' name="taskNo">
                  <Input maxLength={100} placeholder='请输入计划编码' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='计划状态' name="status">
                  <Select placeholder='请选择计划状态'>
                    {
                      Object.keys(statusIndexToText).sort().map(obj =><Option key={obj} value={obj}>{statusIndexToText[obj]}</Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} style={{ textAlign: 'right' }}>
                <Button type='primary' htmlType='submit'>查询</Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>重置</Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div style={{ marginTop: '40px' }}>
          <Table
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={list}
            loading={loading}
            scroll={{ x: 3000 }}
            pagination={{
              pageSize: pageSize,
              total: total,
              current: currentPage,
              onChange: (currentPage, pageSize) => {
                this.setState(
                  {
                    currentPage,
                    pageSize,
                  },
                  () => {
                    this.requestReportedList();
                  }
                );
              },
            }}
          />
        </div>
      </div>
    );
  }
}
export default reportedList;